import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { AssetLink } from '@utils/helpers/asset-cpm-link';
import { IStep } from '../../utils/interfaces/step.interface';
import { TraceService } from '@modules/business-accounts/services/trace/trace.service';
import { uuid } from '@utils/functions/uuid';
import { VisitEvent } from '@modules/business-accounts/utils/classes/visit-event.class';
import { TraceEventName } from '@modules/business-accounts/utils/enums/trace-events.enum';

@Component({
  selector: 'ba-natural-person-startup-step',
  templateUrl: './natural-person-startup-step.component.html',
  styleUrls: ['./natural-person-startup-step.component.scss'],
})
export class NaturalPersonStartupStepComponent extends AssetLink() implements OnInit, IStep<void> {
  @Input() documentNumber!: string;

  @Output() stepDone = new EventEmitter<void>();

  constructor(
    private readonly host: ElementRef<HTMLDivElement>,
    private readonly renderer: Renderer2,
    private readonly traceService: TraceService) {
    super();
  }

  ngOnInit(): void {
    this.renderer.addClass(this.host.nativeElement, 'startup-info-host');
    this.traceService.setCommonInfo({
      traceId: uuid()
    });
  }

  start(): void {
    this.traceService.registerEvent(new VisitEvent(TraceEventName.ACTION_INITIAL));
    this.stepDone.emit();
  }
}
